module.exports = __webpack_public_path__ + "img/enabled.d0aaa6d8.svg";